import API from './api.js';

/**
 * Get all local news sources (Admin only)
 */
export const getLocalSources = async (token) => {
  const response = await API.get('/admin/local-sources', {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

/**
 * Get a single local news source (Admin only)
 */
export const getLocalSource = async (id, token) => {
  const response = await API.get(`/admin/local-sources/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

/**
 * Create a new local news source (Admin only)
 */
export const createLocalSource = async (data, token) => {
  const response = await API.post('/admin/local-sources', data, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

/**
 * Update a local news source (Admin only)
 */
export const updateLocalSource = async (id, data, token) => {
  const response = await API.put(`/admin/local-sources/${id}`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

/**
 * Delete a local news source (Admin only)
 */
export const deleteLocalSource = async (id, token) => {
  const response = await API.delete(`/admin/local-sources/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

/**
 * Test an RSS feed URL (Admin only)
 */
export const testRssFeed = async (rssUrl, token) => {
  const response = await API.post('/admin/local-sources/test-rss', { rssUrl }, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};
